import DesignCard from 'components/card/DesignCard';

export type KpiCardTone = 'default' | 'positive' | 'danger';

export type KpiProgressSegment = {
  /** Share of the bar, 0..1. */
  fraction: number;
  /** Background class of the segment, e.g. `bg-design-green`. */
  className: string;
};

export type KpiCardProps = {
  label: string;
  value: string | number;
  sub?: string;
  tone?: KpiCardTone;
  /** 6px bar under the value, split in coloured segments. */
  progress?: { segments: KpiProgressSegment[] };
  /** Type scale of the value; `text-4xl` unless a hero KPI asks for more. */
  valueClassName?: string;
  className?: string;
};

const toneClasses: Record<KpiCardTone, string> = {
  default: '',
  positive: 'text-design-green',
  danger: 'text-darker-red',
};

const KpiCard = ({
  label,
  value,
  sub,
  tone,
  progress,
  valueClassName,
  className,
}: KpiCardProps) => (
  <DesignCard title={label} className={className}>
    <div
      aria-label={label}
      className={`font-bold ${valueClassName ?? 'text-4xl'} ${
        toneClasses[tone ?? 'default']
      }`}
    >
      {value}
    </div>
    {sub && (
      <div className="mt-1 text-xs text-light-black dark:text-sublte-white">
        {sub}
      </div>
    )}
    {progress && (
      <div
        role="img"
        aria-label={`${label} progress`}
        className="mt-3 flex h-1.5 w-full overflow-hidden rounded-sm bg-design-secondary-black"
      >
        {progress.segments.map((segment) => (
          <div
            key={segment.className}
            className={segment.className}
            style={{
              width: `${Math.max(0, Math.min(1, segment.fraction)) * 100}%`,
            }}
          />
        ))}
      </div>
    )}
  </DesignCard>
);

KpiCard.defaultProps = {
  sub: undefined,
  tone: 'default',
  progress: undefined,
  valueClassName: 'text-4xl',
  className: '',
};

export default KpiCard;
